<template>
  <div
    class="squircle-md bg-surface-raised group flex flex-col gap-2 rounded border"
    :class="{
      'min-w-56': linkedToNotification
    }"
  >
    <div class="flex flex-row items-center gap-3">
      <div
        class="squircle-l-md bg-primary-100 relative flex aspect-square h-14 min-w-0 items-center justify-center overflow-hidden rounded-l"
      >
        <div
          v-if="!linkedToNotification"
          class="absolute inset-0 flex items-center justify-center"
          :class="{
            'opacity-0 group-hover:opacity-100': !alreadyAttachedAttachments
          }"
        >
          <button
            v-if="alreadyAttachedAttachments"
            class="flex size-6 items-center justify-center rounded-full border bg-red-500 text-white"
            @click="$emit('remove-attachment')"
          >
            <FontAwesomeIcon :icon="['fas', 'times']" size="xs" />
          </button>
          <button
            v-else
            class="bg-primary text-contrast-primary flex size-6 items-center justify-center rounded-full border"
            @click="$emit('add-attachment')"
          >
            <FontAwesomeIcon :icon="['fas', 'arrow-left']" size="xs" />
          </button>
        </div>
        <img
          v-if="imgValid"
          :src="imgSrc"
          class="inset-0 block aspect-square h-full w-full object-cover"
          @error="imgError = true"
        />
        <FontAwesomeIcon v-else :icon="['fal', 'file']" size="xl" />
      </div>
      <div
        class="flex min-w-0 flex-1 flex-col py-3"
        :class="{
          'pr-3': !linkedToNotification || !canDeleteAttachment
        }"
      >
        <a
          v-if="attachment?.original_url"
          class="truncate font-bold"
          :href="attachment.original_url"
          target="_blank"
        >
          {{ attachment.name ?? attachment.title }}
        </a>
        <h4 v-else class="truncate font-bold">
          {{ attachment.name ?? attachment.title }}
        </h4>
      </div>
      <div
        v-if="linkedToNotification && canDeleteAttachment"
        class="flex h-full items-center justify-center pr-3"
      >
        <BaseDropDownMenu
          :options="[
            {
              label: $t('button.delete'),
              icon: 'trash',
              gate: true,
              bg_color: 'bg-red-500',
              txt_color: 'text-white',
              action: () => $emit('remove-attachment')
            }
          ]"
          size="small"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BaseDropDownMenu from '@c/addf-package/components/dropdown/BaseDropDownMenu.vue'

export default {
  name: 'AttachmentComponent',
  components: { BaseDropDownMenu, FontAwesomeIcon },
  props: {
    attachment: {
      type: Object,
      required: true
    },
    linkedToNotification: {
      type: Boolean,
      required: true
    },
    alreadyAttachedAttachments: {
      type: Boolean,
      required: false,
      default: false
    },
    canDeleteAttachment: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['remove-attachment', 'add-attachment'],
  data() {
    return {
      imgError: false
    }
  },
  computed: {
    imgValid() {
      return this.imgSrc && !this.imgError
    },
    imgSrc() {
      return this.linkedToNotification
        ? this.attachment.preview_url
        : this.attachment.object.preview_url
    }
  }
}
</script>

<style scoped></style>
